"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3 5H1v18h18v-2H3zm20-4H5v18h18zm-2 16H7V3h14z"
}), 'FilterNoneSharp');